import React, { useEffect, useState } from "react";
import { familyPoemsProgress, storiesChildren, storiesOverview } from "./api";
import { MyProgressCards } from "./ProgressCards";

// Progress for an individual or family account: the same cards a teacher and a principal get, for this account's learners.
// Poems gives the numbers per child; Stories adds the stories each one has finished. Either app can be unavailable on the
// plan: the page then shows what it can.
export default function MyProgress({ token, name }) {
  const [poems, setPoems] = useState(undefined);      // undefined = loading, null = not available
  const [stories, setStories] = useState(undefined);
  useEffect(() => {
    let alive = true;
    familyPoemsProgress(token).then((d) => alive && setPoems(d)).catch(() => alive && setPoems(null));
    Promise.all([storiesChildren(token), storiesOverview(token)]).then(([c, o]) => {
      if (!alive) return;
      const byProfile = {};
      (c.children || []).forEach((k) => { byProfile[k.id] = k.completed || 0; });
      setStories({ me: (o && o.completed_count) || 0, byProfile });
    }).catch(() => alive && setStories(null));
    return () => { alive = false; };
  }, [token]);
  if (poems === undefined || stories === undefined) return <div className="text-forest-700">Loading…</div>;
  return (
    <div className="space-y-5" data-testid="my-progress-page">
      <div>
        <h1 className="font-display font-semibold text-2xl text-forest-700">Progress</h1>
        <p className="text-sm text-foreground/70 mt-1">How each child is getting on in Poems and Stories.</p>
      </div>
      <MyProgressCards data={poems || { per_child: 0, poems_total: 0, steps: 5, learners: [] }} stories={stories} meName={name} />
    </div>
  );
}
